import React from 'react'
import { useTranslation } from 'i18n'
import { MyBooksWrapper, WrittenBooksHistoryLink } from './MyBooks.styles'

const MyBooks: React.FC = () => {
  const { t } = useTranslation()

  return (
    <MyBooksWrapper>
      <h5>{t('Histórico de livros escritos')}</h5>
      <p>
        {t(
          'Veja seus livros escritos anteriormente em Criar em 2025 ou anos anteriores.'
        )}
      </p>
      <WrittenBooksHistoryLink href="https://livros.arvore.com.br/oidc/authorize?client_id=QHFYIJDJQMAWQVDU&response_type=code&state=%2Fbiblioteca&redirect_uri=https://criar.arvore.com.br/oauth/arvore/redirect_url">
        {t('Ver histórico')}
      </WrittenBooksHistoryLink>
    </MyBooksWrapper>
  )
}

export default MyBooks
